<div class="d-flex align-items-center justify-content-center h-100">
  <div
    class="sortable-list d-flex flex-wrap gap-4 justify-content-center"
    (dragover)="onDragOver($event)"
    (dragenter)="onDragEnter($event)"
  >
    <div
      class="item p-4"
      *ngFor="let chart of charts$ | async"
      draggable="true"
      (dragstart)="onDragStart($event)"
      (dragend)="onDragEnd($event)"
      style="
        background-color: rgb(255, 255, 255);
        border-radius: 6px;
        border: 1px solid rgb(180, 180, 180);
        width: clamp(350px, calc(33% - 3rem), 33%);
      "
    >
      <div
        class="d-flex flex-row justify-content-between align-self-center py-1"
      >
        <div class="fs-5 fw-light text-nowrap overflow-hidden text-truncate">
          {{ chart.title }}
        </div>
        <div
          *ngIf="inLive"
          style="color: green"
          class="d-flex flex-row align-items-center gap-2"
        >
          <svg width="8" height="8" fill="currentColor" viewBox="0 0 16 16">
            <circle cx="8" cy="8" r="8" />
          </svg>
          <samp class="text-uppercase text-nowrap overflow-hidden text-truncate"
            >Datos en vivo</samp
          >
        </div>
      </div>
      <div class="d-flex flex-row justify-content-between border">
        <app-chart
          class="border w-75"
          [type]="chart.type"
          [data]="chart.data"
          [optios]="chart.options"
        ></app-chart>
        <!-- A ingresar los datos type, data, options-->
        <div class="border w-25 pt-2">
          <div>Options</div>
        </div>
      </div>
    </div>
  </div>
</div>
